module.exports = __webpack_public_path__ + "img/line_ebm_logo.1c36087b.png";